import React from 'react';
import Loadable from 'react-loadable';

const LoadableComponent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'WithBreakingNews' */ './WithBreakingNews'),
  loading: () => null,
});

export default class WithLazyLoadBreakingNews extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  componentDidMount() {
    const brknewsCloseExist = window.sessionStorage
      ? sessionStorage.getItem('brknewsClose') !== '1'
      : true;
    if (brknewsCloseExist) {
      setTimeout(() => {
        this.setState({ load: true });
      }, 1000);
    }
  }

  render() {
    if (!this.state.load) {
      return null;
    }
    return <LoadableComponent {...this.props} closeWidget={this.closeWidget} />;
  }
}
